import React from 'react'
import Layout from '../../../components/common/pageLayout'
import Form from '../../../components/Administration/users/form'
import { v3_edit_user } from '../../../actions/v3/user'
import constant from '../../../constant'
import { toast } from 'react-toastify'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
const Add = (props) => {

    const location = useLocation();
    const { userData, page } = location.state || {};
    const onSubmit = (model) => {
        v3_edit_user(model).then((res) => {
            if (res.status) {
                toast.success(res.result.message)
                props.history.push(constant.Authedcomponent.listUser.url, {
                    page: page // Replace 'yourData' with the data you want to pass
                });

            }
            else {
                toast.error(res.error)
            }
        })
    }
    return (
        <React.Fragment>
            <Layout
                title={'Edit Admin User'}>
                <Form
                    title={'Edit Admin User'}
                    onSubmit={onSubmit}
                    data={JSON.parse(atob(userData))}
                    buttonName={'Save User'}

                />
            </Layout>

        </React.Fragment>
    )
}

export default Add